import React from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import PanelLayout from "../components/PanelLayout";
import ModifierInputPortList from "../components/ModifierInputPortList";

const FieldModifierPanel = (props) => {
    return (
        <PanelLayout>
            <ModifierInputPortList clickedNode={props.clickedNodeInfo}
                                   clickedAction={props.clickedNodeAction}/>
        </PanelLayout>
    );
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {hideModal, clickedNodeAction})(FieldModifierPanel);